module.exports = __webpack_public_path__ + "img/rightArrowW.75ce413c.svg";